export default __webpack_public_path__ + "assets/delete-field.bf07897a.png";